import axiosInstance from '../../utils/axios';

export const createOrUpdateConstructionSequence = async (sequenceData) => {
  try {
    const dataToSend = Array.isArray(sequenceData) ? sequenceData : [sequenceData];
    
    const response = await axiosInstance.post(
      `/create_or_update_construction_sequence`,
      dataToSend
    );
    
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const getAllConstructionSequence = async () => {
  try {
    const response = await axiosInstance.get(
      `/get_all_construction_sequence`
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (err) {
    throw err;
  }
};

export const deleteConstructionSequence = async (id) => {
  try {
    const sequenceId = id?.id || id;
    if (!sequenceId) {
      throw new Error('Invalid sequence ID');
    }

    const response = await axiosInstance.delete(
      `/create_or_update_construction_sequence?id=${encodeURIComponent(sequenceId)}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};